module.exports = __webpack_public_path__ + "img/couples-022.eeda717e.jpg";